import React, { useState, useEffect } from "react";
import juniorlogo1 from "assets/img/Juniorlogo1.png";


import briefcase from "assets/img/briefcase.png";
import exam from "assets/img/exam.png";
import IndexNavbar from "./IndexNavbar";

export default function AdminNavbar() {
  const [dropdownVisible1, setDropdownVisible1] = useState(false);
  const [dropdownVisible2, setDropdownVisible2] = useState(false);
  const [dropdownVisible3, setDropdownVisible3] = useState(false);
  const [dropdownVisible4, setDropdownVisible4] = useState(false);
  const [dropdownVisible5, setDropdownVisible5] = useState(false);
  const [dropdownVisible6, setDropdownVisible6] = useState(false);
  const [dropdownVisible7, setDropdownVisible7] = useState(false);

  const closeAllDropdowns = () => {
    setDropdownVisible1(false);
    setDropdownVisible2(false);
    setDropdownVisible3(false);
    setDropdownVisible4(false);
    setDropdownVisible5(false);
    setDropdownVisible6(false);
    setDropdownVisible7(false);
  };

  const handleMouseEnter = (dropdownNumber) => {
    closeAllDropdowns(); // Close all other dropdowns
    switch (dropdownNumber) {
      case 1:
        setDropdownVisible1(true);
        break;
      case 2:
        setDropdownVisible2(true);
        break;
      case 3:
        setDropdownVisible3(true);
        break;
      case 4:
        setDropdownVisible4(true);
        break;
      case 5:
        setDropdownVisible5(true);
        break;
      case 6:
        setDropdownVisible6(true);
        break;
      case 7:
        setDropdownVisible7(true);
        break;
      default:
        break;
    }
  };

  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <div style={{ position: "relative", zIndex: 999 }}>
        {/* Fixed Header Section */}
        <section
          className={`fixed-on-scroll ${
            isScrolled ? "scrolled" : ""
          } xl:block lg:block md:hidden sm:hidden hidden bg-white`}
        >
          <div className="container mx-auto flex items-center justify-between xl:gap-6 gap-0 pt-4 pb-2">
            {/* Logo */}
            <div className="xl:w-2/12 lg:w-2/12">
              <div className="flex">
                <a href="/homepage1">
                  <img
                    src={juniorlogo1}
                    alt="Logo"
                    className="xl:w-12/12 lg:w-10/12 xl:-ml-4"
                  />
                </a>
              </div>
            </div>

            <div className="flex  xl:gap-12 gap-6 parkinsans textblue xl:ml-0 xl:pt-0  ">
              <div className="dropdown-container">
                <a
                  href="/ourstory"
                  className="xl:text-base cursor-pointer text-sm font-semibold dropdown-trigger"
                >
                  <p className="xl:mt-0 lg:-mt-2">About us</p>
                </a>
                <div className="dropdown-content xl:p-4">
                  <ul
                    className="rounded-md"
                    style={{ border: "1px solid #2d86a4" }}
                  >
                    <li>
                      <a href="/ourstory#mission">Our Vision</a>
                    </li>
                    <li>
                      <a href="/ourstory#team">Our Mission</a>
                    </li>
                    <li>
                      <a href="/ourstory#history">Our Values</a>
                    </li>
                    <li>
                      <a href="/ourstory#history">Our Philosophy</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="relative inline-block xl:pt-2">
                <a
                  href="/entrepreneurial-preschool"
                  className="flex items-center"
                >
                  <p className="xl:text-base cursor-pointer text-sm font-semibold">
                    Curriculum
                  </p>
                </a>
              </div>

              {/* <div className="relative inline-block xl:pt-2">
                <a href="/faqs" className="flex items-center">
                  <p className="xl:text-base cursor-pointer text-sm font-semibold">
                    FAQ
                  </p>
                </a>
              </div> */}

              <div className="relative inline-block xl:pt-2">
                <a href="/career" className="flex items-center">
                  <p className="xl:text-base cursor-pointer text-sm font-semibold">
                    Careers
                  </p>
                </a>
              </div>

              <div className="relative inline-block xl:pt-2">
                <a href="/contact" className="flex items-center">
                  <p className="xl:text-base cursor-pointer text-sm font-semibold">
                    Contact Us
                  </p>
                </a>
              </div>
            </div>

            <div className="flex  xl:gap-6 gap-6 parkinsans textblue xl:ml-0 xl:pt-0 pt-2">
              {/* <div className="relative inline-block xl:pt-2">
                <a href="/ourstory" className="flex items-center">
                  <p className="xl:text-sm cursor-pointer text-sm font-semibold">
                    About us
                  </p>
                </a>
              </div>

              <div className="relative inline-block xl:pt-2">
                <a
                  href="/entrepreneurial-preschool"
                  className="flex items-center"
                >
                  <p className="xl:text-sm cursor-pointer text-sm font-semibold">
                    Way of Learning
                  </p>
                </a>
              </div> */}

              {/* <div className="relative inline-block xl:pt-2">
                <a href="/faqs" className="flex items-center">
                  <p className="xl:text-sm cursor-pointer font-semibold">
                    FAQs
                  </p>
                </a>
              </div> */}

              {/* <div className="relative inline-block xl:pt-2">
                <a href="/career" className="flex items-center">
                  <p className="xl:text-sm cursor-pointer text-sm font-semibold">
                    Careers
                  </p>
                </a>
              </div>

              <div className="relative inline-block xl:pt-2">
                <a href="/contact" className="flex items-center">
                  <p className="xl:text-sm cursor-pointer text-sm font-semibold">
                    Contact Us
                  </p>
                </a>
              </div> */}

              <div>
                <div className="xl:mt-0 -mt-1">
                  <div className="flex items-center xl:gap-2 gap-2 rounded xl:px-4 borderpeach xl:py-3 px-2 py-1">
                    <div>
                      <img className="w-4" src={exam} alt="Check Icon" />
                    </div>
                    <a href="/enroll-now">
                      <p className="xl:text-base cursor-pointer text-sm font-semibold">
                        Admission
                      </p>
                    </a>
                  </div>
                </div>
              </div>

              <div className="xl:mr-0 mr-2 xl:mt-0 -mt-1">
                <div
                  className="flex items-center xl:gap-2 gap-2  rounded xl:px-4  xl:py-3 px-2 py-1"
                  style={{ background: "#0189A5" }}
                >
                  <img className="w-4" src={briefcase} alt="Check Icon" />
                  <a href="/become-partner">
                    <p className="xl:text-base cursor-pointer text-sm font-semibold text-white">
                      Become A Partner
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="xl:hidden lg:hidden md:block sm:block block">
          <div>
            <IndexNavbar />
          </div>
        </section>
      </div>
    </>
  );
}
